<script>
  import { router } from '../../../../../bootstrap';
  import { EventBus } from 'utils/event-bus';

  export default {
    mounted() {
      const integration_id = this.$route.query.integration_id;
      if (integration_id) {
        const school_id = sessionStorage.getItem(
          'admin_integrations_school_id'
        );
        if (school_id) {
          this.$store
            .dispatch('associateEdlinkIntegrationWithSchool', {
              school_id,
              integration_id,
            })
            .then((data) => {
              sessionStorage.removeItem('admin_integrations_school_id');
              return router.push({
                name: 'admin-integrations',
                params: { schoolID: data.id },
              });
            })
            .catch((err) => {
              console.error(err);
              EventBus.$emit(
                'toast-msg',
                'This integration is already integrated with this school.'
              );
              return router.push({
                name: 'admin-integrations',
                params: { schoolID: school_id },
              });
            });
        } else {
          setTimeout(() => {
            EventBus.$emit(
              'toast-msg',
              'There was a problem associating your school with the Edlink integration.'
            );
            return router.push({
              name: 'dashboard',
            });
          }, 1000);
        }
      } else {
        setTimeout(() => {
          EventBus.$emit('toast-msg', 'No integration ID was provided.');
          return router.push({
            name: 'dashboard',
          });
        }, 1000);
      }
    },
  };
</script>



// WEBPACK FOOTER //
// adminPortalIntegrationsRedirectComponent.vue?26499504